var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let New = class New extends LitElement {
    static { this.styles = css `
    .edit-module {
      position: relative;
      min-height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      outline: 3px dashed #E1E3E8;
      outline-offset: -10px;
      border-radius: 20px;
      text-align: center;
    }
    .add-btn {
      padding: 0;
      margin: 0;
      border: 0;
      border-radius: 50%;
      font-size: .75rem;
      font-family: system-ui, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';
      font-weight: 600;
      color: #333840;
      background-color: #E1E3E8;
      cursor: pointer;
      height: 40px;
      width: 40px;
      line-height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.25s ease;
    }

    .edit-module:hover .add-btn {
      color: white;
      background-color: #1B7E4B;
    }

    .edit-module:hover {
      outline: 3px dashed #D5D7DB;
    }

    .edit-module .add-btn:hover {
      background-color: #24aa65;
      color: #fff;
    }
  `; }
    constructor() {
        super();
    }
    add() {
        window.parent.postMessage({ type: 'add', area: this.area });
    }
    render() {
        return html ` <div class="edit-module"> <button @click=${() => this.add()} class="add-btn before" data-guid=${this.guid} data-position="before"> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/> </svg> </button> </div> `;
    }
};
__decorate([
    property({ type: String })
], New.prototype, "guid", void 0);
__decorate([
    property({ type: String })
], New.prototype, "area", void 0);
New = __decorate([
    customElement('p-new')
], New);
export { New };
